export default __webpack_public_path__ + "ae68c0ea85644fbb0107095c9458c245.png";